import ProjectService, { ProjectViewModel } from '../../../services/ProjectService';
import 'bootstrap/dist/css/bootstrap.min.css';
import { Col, Row } from 'react-bootstrap';
import { ImportSection } from './ImportSection';
import { ExportSection } from './ExportSection';
import moment from 'moment';
import { Trans } from 'react-i18next';
import { PermissionButton } from 'components/PermissionButton';
import { Button } from '@progress/kendo-react-buttons';
import { Dialog } from '@progress/kendo-react-dialogs';
import { useState } from 'react';
import { t } from 'i18next';
import { useNotification } from 'contexts/NotificationContext';
import { Link } from 'react-router-dom';


export default function ProjectComponent({ projectDetails }: { projectDetails: ProjectViewModel }) {
  const projectService = new ProjectService();
  const [showDialogClean, setShowDialogClean] = useState(false);
  const [showDialogImport, setShowDialogImport] = useState(false);
  const [showDialogExport, setShowDialogExport] = useState(false);
  const notifications = useNotification();

  const handleCleanQueue = () => {
    setShowDialogClean(true);
  };

  const confirmCleanQueue = () => {
    projectService.ImportCleanQueue();
    setShowDialogClean(false);
    notifications.showNotification( t("configuration.projects.cleanQueueSuccess"),"info");
  };

  const cancelCleanQueue = () => {
    setShowDialogClean(false);
  };

  const handleImport = () => {
    setShowDialogImport(true);
  };

  const confirmImport = () => {
    projectService.ImportRetry();
    setShowDialogImport(false);
    notifications.showNotification( t("configuration.projects.importRetrySuccess"),"info");
  };

  const cancelImport = () => {
    setShowDialogImport(false);
  };

  const handleExport = () => {
    setShowDialogExport(true);
  };

  const confirmExport = () => {
    projectService.ExportProject();
    setShowDialogExport(false);
    notifications.showNotification( t("configuration.projects.exportNowSuccess"),"info");
  };

  const cancelExport = () => {
    setShowDialogExport(false);
  };

  return (
    <>
      <div className="g-4 px-4">
          <Row className="border rounded tile-content py-3 m-4 d-flex flex-column ">
            <h5 className="title" style={{ paddingLeft: 0 }}>{projectDetails.ProjectDescription}</h5>

            <div>
                {projectDetails ? (
                  <>
                    <Row className="pt-3 g-4">
                      <Col md={6}>
                        <p><b><Trans>general.status</Trans>:</b> {projectDetails.Status}</p>
                        <p><b><Trans>configuration.projects.code</Trans>:</b> {projectDetails.ProjectCode} </p>
                        <p><b><Trans>configuration.projects.createdOn</Trans>:</b> {moment(projectDetails.CreatedAt).format("YYYY-MM-DD")}</p>
                      </Col>
                      <Col md={6}>
                        <p><b><Trans>configuration.projects.activeOptions</Trans>:</b> {projectDetails.ActiveOptions}</p>
                        <p><b><Trans>configuration.projects.exportSchedule</Trans>:</b> {projectDetails.ExportSchedule}</p>
                      </Col>
                    </Row>
                    <Row >
                      <Col className='text-end'>
                      <Link to="/project/projectNotificationEmails" className="btn btn-primary mx-2"
                          style={{ width: '200px' }}>
                          <Trans>configuration.projects.notificationEmails</Trans>
                        </Link>
                      <PermissionButton code="configuration_projects_recovery" visible={false} mode="edit">        
                        <Button
                          title="Retry Import"
                          themeColor={"primary"}
                          onClick={handleImport} 
                          className='mx-2'
                          style={{ width: '200px' }}>
                          <Trans>configuration.projects.runNewImport</Trans>
                        </Button>
                      </PermissionButton>
                      <PermissionButton code="configuration_projects_recovery" visible={false} mode="edit">        
                        <Button 
                            title="Clean import queue"
                            themeColor={"primary"}
                            onClick={handleCleanQueue} 
                            className='mx-2'
                            style={{ width: '200px' }}>
                          <Trans>configuration.projects.cleanFailedImportQueue</Trans>
                        </Button>
                      </PermissionButton>
                      <PermissionButton code="configuration_projects_export" visible={false} mode="edit">        
                        <Button 
                          title="Export now"
                          themeColor={"primary"}
                          onClick={handleExport}
                          style={{ width: '200px' }}>
                          <Trans>configuration.projects.runNewExport</Trans>
                        </Button>
                      </PermissionButton>
                      </Col>
                    </Row>
                  </>
                ) : (
                    <p><Trans>configuration.projects.loadingProjectDetails</Trans></p>
                )}
            </div>
          </Row>
          <Row>
            <Col md={6}>
              <ImportSection importData={projectDetails.ImportDataflow} />
            </Col>
            <Col md={6}>
              <ExportSection exportData={projectDetails.ExportDataflow} />
            </Col>
          </Row>   
      </div>
      

      {showDialogClean && (
        <Dialog title={t("general.confirmAction")} onClose={cancelCleanQueue}>
          <p><Trans>configuration.projects.cleanFailedImportQueueDialog</Trans></p>

          <div className="k-dialog-buttons  d-flex justify-content-between">
            <Button themeColor="primary" onClick={confirmCleanQueue}>
              <Trans>configuration.projects.cleanFailedImportQueue</Trans>
            </Button>
            <Button onClick={cancelCleanQueue}>
              <Trans>general.cancel</Trans>
            </Button>
          </div>
        </Dialog>
      )} 
      {showDialogImport && (
        <Dialog title={t("general.confirmAction")} onClose={cancelImport}>
          <p><Trans>configuration.projects.retryFailedImportsDialog</Trans></p>
          <div className="k-dialog-buttons d-flex justify-content-between">
            <Button themeColor="primary" onClick={confirmImport}>
            <Trans>configuration.projects.importNow</Trans>
            </Button>
            <Button onClick={cancelImport}>
              <Trans>general.cancel</Trans>
            </Button>
          </div>
        </Dialog>
      )} 
      {showDialogExport && (
        <Dialog title={t("general.confirmAction")} onClose={cancelExport}>
          <p><Trans>configuration.projects.exportNowDialog</Trans></p>
          <div className="k-dialog-buttons d-flex justify-content-between">
            <Button themeColor="primary" onClick={confirmExport}>
              <Trans>configuration.projects.exportNow</Trans>
            </Button>
            <Button onClick={cancelExport}>
              <Trans>general.cancel</Trans>
            </Button>
          </div>
        </Dialog>
      )} 
    </>
    
  );
}